import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EntityCrudService } from '@data/entity-crud.service';
import {
  IUpdateSessionJobDatasetRequest,
  SessionJobDataset,
} from '@data/session-job-dataset/session-job-dataset.model';

export interface SessionJobDatasetOptions {
  studyFields: any[];
  coursesGeneral: any[];
  branches: any[];
  topics: any[];
}

@Injectable({
  providedIn: 'root',
})
export class SessionJobDatasetService extends EntityCrudService<
  IUpdateSessionJobDatasetRequest,
  SessionJobDataset
> {
  constructor() {
    const http = inject(HttpClient);

    super('session-job-data', http);
  }

  /**
   * Resolved option lists of one dataset. The public exhibitor form cannot use the per-collection
   * list endpoints — those are `/private/*` and an anonymous exhibitor has no token, so the
   * requests never even leave the interceptor and every chip field ends up without options.
   */
  getOptions(id: string): Observable<SessionJobDatasetOptions> {
    return this.http.get<SessionJobDatasetOptions>(`${this.URL_PUBLIC}/${id}/options`);
  }
}
